import { GPIErrorCodes } from '../enums';

export type GPIErrorResponse = {
	error: {
		code: GPIErrorCodes;
		info: string;
		message: string;
		detail?: {
			description: string;
			data_path: string;
		}[];
	};
};

export const isValidGPIError = (response: unknown): response is GPIErrorResponse => {
	return (
		typeof response === 'object' &&
		response !== null &&
		'error' in response &&
		typeof response.error === 'object' &&
		response.error !== null &&
		'code' in response.error &&
		typeof response.error.code === 'string' &&
		Object.values(GPIErrorCodes).includes(response?.error?.code as GPIErrorCodes)
	);
};

export type GPIDeclineError = {
	status: string;
	processor_response: string;
};

export const isValidGPIDeclineError = (response: unknown): response is GPIDeclineError => {
	return (
		typeof response === 'object' &&
		response !== null &&
		'status' in response &&
		typeof response.status === 'string' &&
		'processor_response' in response &&
		typeof response.processor_response === 'string'
	);
};
